import * as lenis from './lenis'

export default el => {
    const offset = 20;
    const btnMenu = el.querySelector('.js-header-btn-menu');
    const submenus = el.querySelectorAll('.js-header-submenu');
    const logo_rexel = el.querySelector('.logo-rexel');
    const logo_cp = el.querySelector('.logo-cp');
    const nav_links_desktop = el.querySelectorAll("a");
    const nav = document.getElementById("nav-mobile");
    const btn_switch = nav.querySelector('.btn-switch');
    const panel_corpo = nav.querySelector(".panel-corpo");
    const panel_cp = nav.querySelector(".panel-cp");
    const nav_links_mobile = nav.querySelectorAll("a");

    panel_corpo.style.setProperty("--height", `${panel_corpo.querySelector(".links").clientHeight}px`);
    panel_cp.style.setProperty("--height", `${panel_cp.querySelector(".links").clientHeight}px`);

    btn_switch.onclick = () => {
        nav.classList.toggle("cp");
    }

    nav_links_mobile.forEach(link => link.addEventListener("click", () => {
        close();
    }));

    const setActive = selected => {
        nav_links_desktop.forEach(link => link.classList[selected === link ? "add" : "remove"]("active"));
    }

    nav_links_desktop.forEach(link => link.addEventListener("click", () => {
        setActive(link)

        // close search dialog
        document.querySelectorAll(".dialog__search").forEach(dialog => {
            dialog.setAttribute("aria-modal", false);
        });
    }));


    logo_rexel.onclick = e => {
        e.preventDefault();
        el.classList.remove("cp");

        pointerEvents();
    }

    logo_cp.onclick = e => {
        e.preventDefault();
        el.classList.add("cp");

        pointerEvents();
    }

    var is_menu_open = false;

    const pointerEvents = () => {
        el.style.pointerEvents = "none";

        setTimeout(() => {
            document.addEventListener("mousemove", () => {
                el.style.pointerEvents = "auto";
            }, { once: true })
        }, 1000);
    }

    const light = () => {
        if (is_menu_open == true || el.classList.contains('is-light')) return;
        el.classList[window.scrollY > offset ? 'add' : 'remove']('light');
    }

    window.addEventListener('scroll', e => light());

    light();

    const open = () => {
        lenis.destroy();
        nav.scrollTo(0, 0);
        lenis.init(nav);
        el.classList.remove('light');
        nav.setAttribute('aria-modal', true);
        btnMenu.classList.add('active');
        is_menu_open = true;
    }

    const close = () => {
        lenis.destroy();
        lenis.init();
        nav.removeAttribute('aria-modal');
        is_menu_open = false;
        btnMenu.classList.remove('active');
        if (window.scrollY < offset && !el.classList.contains('is-light')) {
            el.classList.remove('light');
            return;
        }

        setTimeout(() => {
            el.classList.add('light');
        }, 500);
    }

    btnMenu.addEventListener('click', () => {
        const status = nav.getAttribute('aria-modal');

        if (!status || status == "false") {
            open();

        } else {
            close();

        }
    })

    submenus.forEach(submenu => {
        submenu.addEventListener('mouseover', (e) => {
            document.body.classList.add('layered');
        });

        submenu.addEventListener('mouseout', (e) => {
            document.body.classList.remove('layered');
        });

        submenu.addEventListener('click', (e) => {
            submenu.classList.toggle('active');
        });
    })
};
